import React, {Component} from 'react';

import BaseBtn from '../../Buttons/BaseBtn';

import * as UserService from '../../../services/User/UserService';
import Loading from "../Loading";

const initialState = {
    requestName: '이름',
    requestCenter: '학원이름',
    requestParentsCallNum: '숫자만 입력 ex.01012341234',
    requestCallNum: '숫자만 입력 ex.01012341234',
    requestBirthday: '년, 월, 일 순으로 총 8자리 ex.19000101',

    isFindID: false,
    isFindPW: false,
    isSubmit: false,
    
    // loading
    isLoadingHide: true
}

class PopupFindForm extends Component {
    state = {
        requestName: '이름',
        requestParentsCallNum: '숫자만 입력 ex.01012341234',
        requestCallNum: '숫자만 입력 ex.01012341234',
        requestCenter: '학원이름',
        requestBirthday: '년, 월, 일 순으로 총 8자리 ex.19000101',

        visible: false,
        isFindData: '',
        isFindID: false,
        isFindPW: false,
        isStudentForm: true,
        isSubmit: false,

        resultID: '',
        resultPW: '',

        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            visible: nextProps.active,
            isFindData: nextProps.data
        });
    }

    closePopup = () => {
        if (this.state.visible) {
            this.setState(initialState);
            this.props.onCancel();
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    findFormChoose = (value) => {
        this.setState(initialState);
        if (value === 'I_TEACHER') {
            this.setState({
                isStudentForm: false
            });
        } else {
            this.setState({
                isStudentForm: true
            });
        }
    }

    userValidation = (identity) => {
        if (this.state.requestName == null || (this.state.requestName != null && this.state.requestName.trim() == '')
            || (this.state.requestName != null && this.state.requestName == '이름')) {
            alert('이름을 입력해 주세요.');
            return false;
        }

        if (identity === 'I_TEACHER') {
            if (this.state.requestCenter === null || (this.state.requestCenter != null && this.state.requestCenter.trim() == '')
                || (this.state.requestCenter != null && this.state.requestCenter == '학원이름')) {
                alert('학원이름을 입력해 주세요.');
                return false;
            }

            if (this.state.requestBirthday === null || (this.state.requestBirthday != null && this.state.requestBirthday.trim() == '')
            || (this.state.requestBirthday != null && this.state.requestBirthday == '년, 월, 일 순으로 총 8자리 ex.19000101')) {
                alert('생년월일을 입력해 주세요.');
                return false;
            } else {
                const regexType = /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/;
                if ( !regexType.test(this.state.requestBirthday) || this.state.requestBirthday.length != 8) {
                    alert('생년월일을 19001231 형식으로 입력해 주세요.');
                    return false;
                }
            }
        }

        if (this.state.isStudentForm) {
            if (this.state.requestParentsCallNum == null || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum.trim() == '')
                || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum == '숫자만 입력 ex.01012341234')) {
                alert('부모님 전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if ( !regexType.test(this.state.requestParentsCallNum) ) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        } else {
            if (this.state.requestCallNum == null || (this.state.requestCallNum != null && this.state.requestCallNum.trim() == '')
                || (this.state.requestCallNum != null && this.state.requestCallNum == '숫자만 입력 ex.01012341234')) {
                alert('전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if ( !regexType.test(this.state.requestCallNum) ) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        }
        return true;
    }

    findUser = (identity, data) => {
        if (!this.userValidation(identity)) {
            return false;
        }

        let name = this.state.requestName;
        let academy = this.state.requestCenter;
        let phone = identity === 'I_STUDENT' ? this.state.requestParentsCallNum : this.state.requestCallNum;
        let birth = this.state.requestBirthday;

        if (data === 'id') {
            UserService.isFindID(name, academy, phone, identity, birth).then((response) => {
                if (response !== null && response.status === 200) {
                    if (response.data.code === '0000') {
                        this.setState({
                            isFindID: true,
                            resultID: response.data.data.username
                        });
                    }
    
                    this.setState({
                        isSubmit: true
                    });
                }
            }).catch((error) => {
                console.log(error);
                alert('SERVER ERROR');
            });
        } else if (data === 'pw') {
            UserService.isFindPW(name, academy, phone, identity, birth).then((response) => {
                if (response !== null && response.status === 200) {
                    if (response.data.code === '0000') {
                        this.setState({
                            isFindPW: true,
                            resultPW: response.data.data.password
                        });
                    }

                    this.setState({
                        isSubmit: true
                    });
                }
            }).catch((error) => {
                console.log(error);
                alert('SERVER ERROR');
            });
        }
    }


    result = () => {
        if (this.state.isFindID) {
            return (
                <div className="resultWrapper">
                    <div className="resultBox success">
                        <span>회원님의 ID는 <strong>{this.state.resultID}</strong> 입니다</span>
                    </div>
                </div>
            );
        } else if (this.state.isFindPW) {
            return (
                <div className="resultWrapper">
                    <div className="resultBox success">
                        <span>회원님의 비밀번호는 <strong>{this.state.resultPW}</strong> 입니다</span>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="resultWrapper">
                    <div className="resultBox">
                        <span>일치하는 회원 정보가 없습니다.</span>
                    </div>
                </div>
            );
        }
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        const {requestName, requestParentsCallNum, requestCenter, requestCallNum, requestBirthday, isFindData, isSubmit} = this.state;

        return (
            this.state.visible ?
                <div className="findPopupWrapper">
                    <div className="findPopup">
                        <div className="findFormWrapper">
                            {/*<form name="findData" className="findForm">
                                <fieldset>*/}
                                    <legend className="screenOut">아이디찾기</legend>
                                    <dl className="findFormContents">
                                        <dt className="findTitle">
                                            {isFindData === 'id' ?
                                            <span>아이디 찾기</span>
                                            : <span>비밀번호 찾기</span>}
                                            <button onClick={this.closePopup} className="btnClose">닫기</button>
                                        </dt>
                                        <dd className="contents">
                                            <div className="tabMenu">
                                                <ul>
                                                    <li>
                                                        {/*STUDENT ID / PW*/}
                                                        <span onClick={() => this.findFormChoose('I_STUDENT')}
                                                            className={this.state.isStudentForm ? "studentForm active" : "studentForm"}>학생</span>

                                                        {/*TEACHER ID / PW*/}
                                                        <span onClick={() => this.findFormChoose('I_TEACHER')}
                                                            className={this.state.isStudentForm ? "teacherForm" : "teacherForm active"}>선생님</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="tabContents">
                                                <ul>

                                                    {/*STUDENT FORM*/}
                                                    <li className={this.state.isStudentForm ? "studentForm active" : "studentForm"}>
                                                        <div className="inputWrapper">
                                                            <ul>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestName">
                                                                            <span>이름</span>
                                                                            <input  type="text" placeholder={requestName}
                                                                                    onChange={this.handleChange}
                                                                                    defaultValue=""
                                                                                    name="requestName"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestParentsCallNum">
                                                                            <span>부모님 전화번호</span>
                                                                            <input  type="number"
                                                                                    placeholder={requestParentsCallNum}
                                                                                    onChange={this.handleChange}
                                                                                    name="requestParentsCallNum"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        {isSubmit ? this.result() : null}
                                                        
                                                        <div className="btnWrapper">
                                                            <BaseBtn 
                                                                btnColor={"deepPink"}
                                                                btnName={"확인"}
                                                                link="#"
                                                                onClick={(e) => { e.preventDefault(); this.findUser('I_STUDENT', isFindData);}} />
                                                        </div>
                                                    </li>

                                                    {/*TEACHER FORM*/}
                                                    <li className={this.state.isStudentForm ? "teacherForm" : "teacherForm active"}>
                                                        <div className="inputWrapper">
                                                            <ul>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestName">
                                                                            <span>이름</span>
                                                                            <input  type="text" placeholder={requestName}
                                                                                    onChange={this.handleChange}
                                                                                    name="requestName"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestCenter">
                                                                            <span>학원이름</span>
                                                                            <input  type="text" placeholder={requestCenter}
                                                                                    onChange={this.handleChange}
                                                                                    name="requestCenter"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestBirthday">
                                                                            <span>생년월일</span>
                                                                            <input  type="number" placeholder={requestBirthday}
                                                                                    onChange={this.handleChange}
                                                                                    name="requestBirthday"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span className="customInputBox">
                                                                        <label htmlFor="requestCallNum">
                                                                            <span>전화번호</span>
                                                                            <input  type="number"
                                                                                    placeholder={requestCallNum}
                                                                                    onChange={this.handleChange}
                                                                                    name="requestCallNum"/>
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        {isSubmit ? this.result() : null}
                                                        
                                                        <div className="btnWrapper">
                                                            <BaseBtn btnColor={"deepPink"} btnName={"확인"} link="#" onClick={(e) => {e.preventDefault(); this.findUser('I_TEACHER', isFindData);}} />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </dd>
                                    </dl>
                               {/* </fieldset>
                            </form>*/}
                        </div>
                    </div>
                </div>
                : null
        );
    }
}

export default PopupFindForm;


// WEBPACK FOOTER //
// ./src/components/Containers/PopupFindForm/index.js